import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectRunSystems = (state: RootState) =>
  sortBy(state.runSystems.runSystems, 'name');

export const selectActiveRunSystems = (state: RootState) =>
  sortBy(
    state.runSystems.runSystems.filter(x => x.active),
    'name'
  );

export const selectRunSystemArhiving = (state: RootState) =>
  state.runSystems.runSystemArchiving;

export const selectRunSystemErrors = (state: RootState) =>
  state.runSystems.errors;
